import { ComponentDefinition } from '@contentful/experiences-sdk-react';
import {
  COLOR_WHITE,
  COLOR_BLACK,
  COLOR_SLATE,
  COLOR_LIGHT_SLATE,
  COLOR_LIME,
  COLOR_LIGHT_LIME,
  COLOR_ERROR,
  COLOR_NEUTRAL_LIGHT,
  COLOR_NEUTRAL_LIGHTER,
  COLOR_OUTERSPACE,
  COLOR_SIDECAR,
  COLOR_SIDECAR_LIGHTER,
  COLOR_NEUTRAL_DARK,
  COLOR_EARLS_GREEN,
  COLOR_EARLS_GREEN_LIGHT,
  COLOR_NEUTRAL_DARKER,
  COLOR_NEUTRAL_DARKEST,
  COLOR_NEUTRAL_LIGHTEST,
  COLOR_EARLS_GREEN_LIGHTER,
  COLOR_EARLS_GREEN_LIGHTEST,
  COLOR_EARLS_GREEN_DARK,
  COLOR_EARLS_GREEN_DARKER,
  COLOR_EARLS_GREEN_DARKEST
} from '@src/types/colors';

export const IconDefinition: ComponentDefinition = {
  id: 'custom-icon',
  name: 'Icon',
  category: 'Levande Elements',
  variables: {
    name: {
      displayName: 'Icon',
      defaultValue: 'right-arrow-alt',
      group: 'style',
      type: 'Text',
      validations: {
        in: [
          // Below are a selection of Box Icons, not all of them (there are hundreds)
          { value: 'right-arrow-alt', displayName: 'Right Arrow' },
          { value: 'left-arrow-alt', displayName: 'Left Arrow' },
          { value: 'up-arrow-alt', displayName: 'Up Arrow' },
          { value: 'down-arrow-alt', displayName: 'Down Arrow' },
          { value: 'chevron-down', displayName: 'Chevron Down' },
          { value: 'chevron-up', displayName: 'Chevron Up' },
          { value: 'chevron-left', displayName: 'Chevron Left' },
          { value: 'chevron-right', displayName: 'Chevron Right' },
          { value: 'close', displayName: 'Close' },
          { value: 'search', displayName: 'Search' },
          { value: 'user', displayName: 'User' },
          { value: 'phone', displayName: 'Phone' },
          { value: 'email', displayName: 'Email' },
          { value: 'location', displayName: 'Location' },
          { value: 'calendar', displayName: 'Calendar' },
          { value: 'clock', displayName: 'Clock' }
        ]
      }
    },
    type: {
      displayName: 'Type',
      defaultValue: 'default',
      group: 'style',
      type: 'Text',
      validations: {
        in: [
          { value: 'default', displayName: 'Default' },
          { value: 'solid', displayName: 'Solid' },
          { value: 'logo', displayName: 'Logo' }
        ]
      }
    },
    size: {
      displayName: 'Size',
      defaultValue: 'md',
      group: 'style',
      type: 'Text',
      validations: {
        in: [
          { value: 'xs', displayName: 'Extra Small' },
          { value: 'sm', displayName: 'Small' },
          { value: 'md', displayName: 'Medium' },
          { value: 'lg', displayName: 'Large' },
          { value: 'xl', displayName: 'Extra Large' }
        ]
      }
    },
    color: {
      displayName: 'Color',
      defaultValue: 'slate',
      group: 'style',
      type: 'Text',
      validations: {
        in: [
          { value: COLOR_WHITE, displayName: 'White' },
          { value: COLOR_BLACK, displayName: 'Black' },
          { value: COLOR_SLATE, displayName: 'Slate' },
          { value: COLOR_LIGHT_SLATE, displayName: 'Light Slate' },
          { value: COLOR_LIME, displayName: 'Lime' },
          { value: COLOR_LIGHT_LIME, displayName: 'Light Lime' },
          { value: COLOR_ERROR, displayName: 'Error' },
          { value: COLOR_OUTERSPACE, displayName: 'Outerspace' },
          { value: COLOR_SIDECAR, displayName: 'Sidecar' },
          { value: COLOR_SIDECAR_LIGHTER, displayName: 'Sidecar Lighter' },
          { value: COLOR_NEUTRAL_LIGHT, displayName: 'Neutral Light' },
          { value: COLOR_NEUTRAL_LIGHTER, displayName: 'Neutral Lighter' },
          { value: COLOR_NEUTRAL_LIGHTEST, displayName: 'Neutral Lightest' },
          { value: COLOR_NEUTRAL_DARK, displayName: 'Neutral Dark' },
          { value: COLOR_NEUTRAL_DARKER, displayName: 'Neutral Darker' },
          { value: COLOR_NEUTRAL_DARKEST, displayName: 'Neutral Darkest' },
          { value: COLOR_EARLS_GREEN, displayName: 'Earls Green' },
          { value: COLOR_EARLS_GREEN_LIGHT, displayName: 'Earls Green Light' },
          {
            value: COLOR_EARLS_GREEN_LIGHTER,
            displayName: 'Earls Green Lighter'
          },
          {
            value: COLOR_EARLS_GREEN_LIGHTEST,
            displayName: 'Earls Green Lightest'
          },
          {
            value: COLOR_EARLS_GREEN_DARK,
            displayName: 'Earls Green Dark'
          },
          {
            value: COLOR_EARLS_GREEN_DARKER,
            displayName: 'Earls Green Darker'
          },
          {
            value: COLOR_EARLS_GREEN_DARKEST,
            displayName: 'Earls Green Darkest'
          }
        ]
      }
    }
  }
};
